// extracted by mini-css-extract-plugin
export var cancelButton = "_ql-5";
export var content = "_ql-3";
export var createButton = "_ql-6";
export var drawerContainer = "_ql-0";
export var footer = "_ql-2";
export var header = "_ql-1";
export var orderFormColumn = "_ql-4";